import { useLocation } from "react-router-dom";
import { StoreFavouritesList, SuperFavouritesList } from "../components";

export const FavouritesList = () => {
    const { pathname } = useLocation();
    const isStoreAdmin = pathname.includes("store-admin");
    return isStoreAdmin ? <StoreFavouritesList /> : <SuperFavouritesList />;
};
